export default __webpack_public_path__ + "static/media/image-not-available.fa9fed6c.jpg";